import React from 'react';
import { ErrorType, EveError } from '@ver-uds/e-verify';
import { Helmet } from 'react-helmet-async';

const ErrorPage = (): JSX.Element => (
  <>
    <Helmet>
      <title>{ErrorType.GENERAL}</title>
    </Helmet>

    <EveError errorType={ErrorType.GENERAL} product="E-Verify" contact="E-Verify@uscis.dhs.gov" />
  </>
);

export default ErrorPage;
